export const productsSlugs = {
  BRAND_VALUATOR: 'brand_valuator',
  CUSTOMER_SATISFACTION: 'customer-satisfaction',
  BEXIO_SATISFACTION: 'bexio-satisfaction',
};
